@if (loading) {
  <h1><offconon-loading-loader-triangle /></h1>
}

@if (hasError) {
  <h1>
    <offconon-rbac-no-access-rights [redirect_url]="'/cognitive-erp/workplaces'" />
  </h1>
}
